import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, Observable, of, switchMap } from 'rxjs';
import { INVOICING_STATUS } from 'src/app/core/enums/invoicing-status.enum';
import { deepClone } from 'src/app/shared/utils/object.utils';
import { TICKET_REPOSITORY } from '../../domain/tokens/ticket.token';
import { ITicketSerieInfo } from '../../interfaces/ticket-serie-info.interface';
import { Ticket } from '../../domain/model/ticket.model';

@Injectable({
  providedIn: 'root',
})
export class RegisterTicketSerieService {
  private readonly ticketRepository = inject(TICKET_REPOSITORY);
  private readonly destroyRef = inject(DestroyRef);

  execute(payload: ITicketSerieInfo): Observable<Ticket | null> {
    return this.updateTicketSerie(payload);
  }

  private updateTicketSerie(payload: ITicketSerieInfo): Observable<Ticket | null> {
    return this.ticketRepository.getTicketById(payload.ticket_id).pipe(
      takeUntilDestroyed(this.destroyRef),
      switchMap((ticketInfo) => {
        if (ticketInfo) {
          const updatedTicket = deepClone(ticketInfo);

          updatedTicket.updateSerie(payload.serie);
          updatedTicket.updateStatus(INVOICING_STATUS.issued);
          updatedTicket.updateInvoiceModuleExtensions(
            payload.invoice_module_extensions
          );

          return this.ticketRepository
            .saveTicket(updatedTicket)
            .pipe(map(() => updatedTicket));
        }

        return of(null);
      })
    );
  }
}
